import React from "react";

import QueryButton
  from "../components/query/QueryButton";

import "../styles/website.css";
import "../styles/about.css";


const AboutPage = () => {

  return (
    <div className="website">

      <main>

        {/* HERO */}

        <section className="inner-hero">

          <div>

            <span className="section-label">
              ABOUT HARSHA IT
            </span>

            <h1>
              Technology should make
              <span> business simpler.</span>
            </h1>

            <p>
              Harsha IT focuses on creating practical,
              modern and scalable technology solutions
              for businesses and organizations.
            </p>

          </div>

        </section>


        {/* OUR APPROACH */}

        <section className="about-story">

          <div className="about-story-content">

            <span className="section-label">
              OUR APPROACH
            </span>

            <h2>
              We build technology
              around your business.
            </h2>

            <p>
              Every organization has different workflows,
              customers and challenges. Instead of forcing
              businesses into complicated software, our goal
              is to create solutions that fit the way they
              actually work.
            </p>

            <p>
              From websites and e-commerce platforms to
              inventory systems, CRM applications and
              multi-tenant business platforms, we focus on
              creating useful digital products.
            </p>

            <QueryButton>
              Talk to Our Team
            </QueryButton>

          </div>


          <div className="about-stats">

            <div className="about-stat">

              <strong>
                01
              </strong>

              <span>
                Understand
              </span>

              <p>
                We first understand your business and
                its requirements.
              </p>

            </div>


            <div className="about-stat">

              <strong>
                02
              </strong>

              <span>
                Design
              </span>

              <p>
                We design simple experiences around
                your users.
              </p>

            </div>


            <div className="about-stat">

              <strong>
                03
              </strong>

              <span>
                Build
              </span>

              <p>
                We develop scalable and reliable
                technology.
              </p>

            </div>


            <div className="about-stat">

              <strong>
                04
              </strong>

              <span>
                Grow
              </span>

              <p>
                Your platform can evolve as your
                business grows.
              </p>

            </div>

          </div>

        </section>


        {/* INDUSTRIES */}

        <section className="about-industries">

          <div className="section-heading">

            <span className="section-label">
              INDUSTRIES
            </span>

            <h2>
              Built for different
              <span> business environments.</span>
            </h2>

          </div>


          <div className="industry-grid">

            <div>
              Education
            </div>

            <div>
              Restaurants
            </div>

            <div>
              Pharmacy
            </div>

            <div>
              Hospitality
            </div>

            <div>
              Retail
            </div>

            <div>
              Growing Businesses
            </div>

          </div>

        </section>

      </main>

    </div>
  );

};


export default AboutPage;